import React from 'react'

function Blogs() {
  return (
    <>
      <div className='md:p-12 p-10 bg-gradient-to-r from-sky-950 via-cyan-800 to-sky-950 pt-24 md:pt-32 font-custom'>
         <h1 className='text-center text-4xl md:text-6xl text-white font-black tracking-widest'>Blogs</h1>
     </div>
      <div className='flex justify-center items-center h-96 font-custom'>
        <h1 className='text-white text-xl md:text-4xl text-center font-bold'>Blogs Coming Soon ... </h1>
      </div>
      
    </>
  )
}

export default Blogs
